import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Link,
    CircularProgress,
    Tooltip,
    Modal,
    Fade,
    Typography,
    Grid,
    Backdrop,
    Button as MButton,
} from '@material-ui/core';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SurveyService from '../../services/SurveyService';
import AuthContext from '../../context/AuthContext';
import { Link as RLink } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import PublishIcon from '@material-ui/icons/Publish';
import GetAppIcon from '@material-ui/icons/GetApp';
import ContentCopyIcon from '@material-ui/icons/FileCopy';
import { Delete as DeleteIcon } from '@material-ui/icons';
import { useParams } from 'react-router-dom';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    table: {
        width: '100%',
    },
    publish: {
        color: '#4caf50',
    },
    revoke: {
        color: '#f44336',
    },
    title: {
        fontSize: 16,
        fontWeight: 600,
    },
    container: {
        backgroundColor: '#eee',
        padding: 6,
    },
    grow: {
        flexGrow: 1,
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #39AC39',
        borderRadius: 5,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

const SurveyList = () => {
    /**
     * CSS
     */
    const classes = useStyles();
    const { id } = useParams();

    /**
     * STATES
     */
    const [surveys, setSurveys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [activateError, setActivateError] = useState(false);
    const { auth } = useContext(AuthContext);
    const [open, setOpen] = useState(false);
    const [toDelete, setToDelete] = useState(0);

    /**
     * QUERIES
     */
    async function fetch() {
        const data = await SurveyService.getFullfillments(id, auth.token);
        if (data) {
            setSurveys(data.data);
            setLoading(false);
        } else {
            setLoading(false);
            setError(true);
        }
    }

    /**
     * HOOKS
     */
    useEffect(() => {
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * SUBMIT
     */

    const deleteSurveyModal = (id) => {
        setToDelete(id);
        setOpen(true);
    };

    const closeModal = (e) => {
        setOpen(false);
    };

    const deleteSurvey = async () => {
        await SurveyService.deleteSingle(toDelete, auth.token);
        fetch();
        setOpen(false);
    };

    return (
        <Fragment>
            <TableContainer>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Benutzer</TableCell>
                            <TableCell>Ausgefüllt am</TableCell>
                            <TableCell align='right'>Aktionen</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading && (
                            <TableRow>
                                <TableCell align='center' colSpan={4}>
                                    <CircularProgress />
                                </TableCell>
                            </TableRow>
                        )}
                        {error && (
                            <TableRow>
                                <TableCell align='center' colSpan={4}>
                                    Fehler beim Abrufen der Daten
                                </TableCell>
                            </TableRow>
                        )}
                        {surveys.map((survey, index) => (
                            <TableRow key={index}>
                                <TableCell></TableCell>
                                <TableCell>
                                    <Link component={RLink} to={`/umfrage/ansicht/${id}/${survey.uid}`}>
                                        {survey.username}
                                    </Link>
                                </TableCell>
                                <TableCell>{moment(survey.created).format('DD.MM.YYYY')}</TableCell>
                                <TableCell align='right'>
                                    <Tooltip title='Löschen'>
                                        <IconButton
                                            onClick={(e) => deleteSurveyModal(survey.uid)}
                                            size='small'
                                            className={classes.revoke}
                                            aria-label='loeschen'
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Modal
                aria-labelledby='delete-modal-title'
                aria-describedby='delete-modal-description'
                open={open}
                closeAfterTransition
                className={classes.modal}
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <Typography component='h4' variant='h4' id='transition-modal-title'>
                            Löschen?
                        </Typography>
                        <div id='transition-modal-description'>
                            <p>
                                <Typography>
                                    Möchten Sie die Umfrage wirklich löschen? Dieser Vorgang kann nicht rückgängig
                                    gemacht werden.
                                </Typography>
                            </p>
                            <Grid container spacing={2} justify='space-between'>
                                <Grid item>
                                    <MButton onClick={closeModal} variant='outlined' color='primary'>
                                        Abbrechen
                                    </MButton>
                                </Grid>
                                <Grid item>
                                    <MButton onClick={deleteSurvey} variant='outlined' color='secondary'>
                                        Löschen
                                    </MButton>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </Fragment>
    );
};

export default SurveyList;
